import React from 'react';

import { Typography } from '@material-ui/core';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import {
  CustomLink,
  PageHeaderContentContainer,
} from './styles';

import TitlePage from '../../../../shared/components/TitlePage';

import propTypes from 'prop-types';

export function HeaderInfo({ pageLink }) {
  return (
    <PageHeaderContentContainer>
      <TitlePage label="Página de Devolução" />
      <CustomLink href={pageLink} target="_blank" rel="noopener noreferrer">
        <VisibilityOutlinedIcon
          style={{ paddingRight: '6px', fontSize: '18' }}
        />
        <Typography style={{ fontSize: 12 }}>Visualizar Página</Typography>
      </CustomLink>
    </PageHeaderContentContainer>
  );
}

HeaderInfo.propTypes = {
  pageLink: propTypes.string.isRequired,
};
